import { provideComponent, useData } from "scrivito"
import { DataBatchContextProvider } from "shared/context/DataBatchContext"

import { DataGroupWidget } from "./DataGroupWidgetClass"

provideComponent(DataGroupWidget, ({ widget }) => {
  const id = ["DataGroupWidget", widget.id(), useData().dataItem()?.id()].join(
    "-"
  )

  return (
    <DataBatchContextProvider key={id} content={widget} attribute="content" />
  )
})
